<template>
  <div class="pa-6">
    <v-data-table
      v-model="selecteds"
      :headers="headers"
      :items="lessons"
      item-key="title"
      show-select
      class="elevation-0"
      :footer-props="{
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-all-text': 'Tất cả',
      }"
      disable-sort
    >
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} trên
        {{ items.itemsLength }}
      </template>
      <template v-slot:[`item.title`]="{ item }"> {{ item.date | ddmmyyyy }} </template>
      <template v-slot:[`item.duration`]="{ item }"> {{ item.startTime }} - {{ item.endTime }} </template>
      <template v-slot:[`item.countAttended`]="{ item }"> {{ item.countAttended }} / {{ $_get(singleClass, 'students.length', 0) }} </template>
      <div slot="top">
        <div>
          <v-card flat class="px-4 pt-4 mt-4" outlined>
            <p class="text--secondary">
              Đây là thao tác gửi tin nhắn thông tin điểm danh của học viên theo buổi học. Hệ thống sẽ tổng hợp
              lại và gửi thông tin tương ứng của mỗi học viên tới ứng dụng sổ liên lạc điện tử của phụ huynh.
            </p>
            <p class="text--secondary">
              Vui lòng kiểm tra thời khóa biểu và danh sách lớp dưới đây trước khi tiến hành thao tác này.
            </p>
          </v-card>

          <div class="d-flex my-6 justify-space-between">
            <GradeClassStudentSelect :gradeCol="{cols: 12,sm: 12,        md: 6}" :classCol="{cols: 12,sm: 12,md: 6}" disableStudentSelect @changed="gradeClassStudentChange" />
            <v-btn class="search-button ml-2" color="primary" outlined :loading="loading" @click="onSearch"
              >Tìm kiếm</v-btn
            >
          </div>
          <div class="d-flex justify-space-between ps-4 py-2">
            <span :class="selecteds.length ? 'text--primary' : 'text--disabled'">
              {{ selecteds.length ? 'Đã chọn ' + selecteds.length + ' lớp' : 'Chưa chọn' }}
            </span>
            <v-btn
              outlined
              color="primary"
              :disabled="!selecteds.length"
              @click="onConfirmSend"
            >
              Gửi tin nhắn
            </v-btn>
          </div>
        </div>
      </div>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import get from 'lodash-es/get'
import moment from 'moment';

export default {
  components: { GradeClassStudentSelect },
  data() {
    return {
      selecteds: [],
      headers: [
        { text: 'Buổi ngày', value: 'title' },
        { text: 'Diễn ra', value: 'duration', align: 'center' },
        { text: 'Có mặt', value: 'countAttended', align: 'center' },
      ],
      loading: false,
      selectedGrade: {},
      selectedClass: {},
    }
  },
  computed: {
    ...mapState('postCreate', ['lessons', 'singleClass']),
    ...mapGetters('auth', ['profile']),
    selectedTitles() {
      return this.selecteds.map(x => moment(x.date).format('DD/MM/YYYY')).join(',')
    },
  },
  methods: {
    ...mapActions('postCreate', ['fetchLessons', 'fetchOneClass', 'sendDiligence']),
    gradeClassStudentChange(data) {
      this.selectedGrade = { ...data.grade }
      this.selectedClass = { ...data.class }
    },
    async onSearch() {
      const classId = get(this.selectedClass, 'id')
      if (!classId) return this.$alert.error('Vui lòng chọn "lớp học"')
      const lte = moment().endOf('day').toISOString()
      await Promise.all([
        this.fetchLessons({class: classId, date_lte: lte, _sort: {date: -1}, _populate: ''}), 
        this.fetchOneClass(classId)
      ])
    },
    onConfirmSend() {
      this.$dialog.confirm({
        title: 'Gửi thông báo điểm danh',
        text: `Bạn có chắc chắn muốn gửi thông báo điểm danh cho buổi học ngày ${this.selectedTitles}?`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          await this.sendDiligence({
            classTitle: this.singleClass.title, 
            lessonIds: this.selecteds.map(x => x.id),
            staff: this.profile.id
          })
        }
      })
    }
  }
}
</script>
